import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=41f9850e&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41f9850e')) {
      api.createRecord('41f9850e', component.options)
    } else {
      api.reload('41f9850e', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=41f9850e&", function () {
      api.rerender('41f9850e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FabrPFTM6gCb/JS/comp/pricelist.vue"
export default component.exports